export enum District {
  Aachen = 'aachen',
  Dueren = 'dueren',
  Heinsberg = 'heinsberg',
}
